import { defineMessages } from '@jutro/locale';

export default defineMessages({
    paymentSchedule: {
        id: 'ml.gateway.MLPolicyBillingPaymentSchedulePopup.Payment Schedule',
        defaultMessage: 'Payment Schedule'
    },
    close: {
        id: 'ml.gateway.MLPolicyBillingPaymentSchedulePopup.CLOSE',
        defaultMessage: 'CLOSE'
    }
    
});
